// extracted by mini-css-extract-plugin
module.exports = {"link":"login_link__d0B4a"};